import React, { ReactNode, DetailedHTMLProps } from "react";
import { IFieldProps } from "./IFieldProps";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import { AppState } from "../../../common/types";
import { isString } from "lodash";

export interface IColoredFieldProps extends IFieldProps {
  color:
    | string
    | ((
        record: { [key: string]: any } & object,
        source: string | undefined,
        isDarkTheme: boolean
      ) => string);
  backgroundColor:
    | string
    | ((
        record: { [key: string]: any } & object,
        source: string | undefined,
        isDarkTheme: boolean
      ) => string);
}

const ColoredField = (
  props: IColoredFieldProps & { children?: ReactNode } & Omit<
      DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
      "color"
    >
) => {
  const { color, backgroundColor, basePath, ...rest } = props;
  const lightTheme = useSelector((state: AppState) => state.theme);
  return (
    <Box
      style={{
        color: props.record
          ? isString(props.color)
            ? props.color
            : props.color(props.record, props.source, lightTheme === "dark")
          : "auto",
        backgroundColor: props.record
          ? isString(props.backgroundColor)
            ? props.backgroundColor
            : props.backgroundColor(
                props.record,
                props.source,
                lightTheme === "dark"
              )
          : "auto",
      }}
      {...rest}>
      {props.children}
    </Box>
  );
};

export default ColoredField;
